import React from 'react';
import { PrizeBanner } from './PrizeBanner';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import styles from './HowToPlay.module.css';
import Ticket from '../../svg/Ticket.svg';

const steps = [
  {
    icon: <Ticket />,
    heading: "Choose your plan",
    content: <p>Play online via our weekly plans or enter for free via the post</p>
  },
  {
    icon: <img src="https://assets.daymade.co.uk/images/how-it-works/balls.png" alt="Icon of two lottery balls" />,
    heading: "Pick your lucky numbers",
    content: <p>Pick 4 main numbers and 1 bonus number</p>
  },
  {
    icon: <>🏆</>,
    heading: "Match numbers to win ",
    content: <p>The more numbers you match, the bigger the prize you can choose</p>
  },
];



interface Props {
  prizeTier: string | undefined;
  premiumCriteria: string | undefined;
  liteCriteria: string | undefined;
  freemiumCriteria: string | undefined;
  boostRequired: boolean | undefined;
}

export function HowToPlay({
  prizeTier,
  premiumCriteria,
  liteCriteria,
  freemiumCriteria,
  boostRequired,
}: Props) {

  return (
    <AboutUsModule background="tealGradient">
      <AboutUsSiteContainer>
        <h2 className="aboutUsTypographyHeaderXlarge">How to play</h2>
        <ol className={styles.list}>
          {steps.map((x, i) => (
            <li key={i}>
              <span className={styles.icon}>{x.icon}</span>
              <div className={styles.text}>
                <h3 className="aboutUsTypographyHeaderMedium">{x.heading}</h3>
                {x.content}
              </div>
            </li>
          ))}
        </ol>
        
        {(premiumCriteria || liteCriteria || freemiumCriteria) && (
          <div className="mt-10 flex justify-center">
            <PrizeBanner
              premiumCriteria={premiumCriteria}
              liteCriteria={liteCriteria}
              freemiumCriteria={freemiumCriteria}
              boostRequired={boostRequired || false}
              prizeTier={prizeTier}
            />
          </div>
        )}
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
}
